module.exports = __webpack_public_path__ + "assets/images/statue-02.9e491f7e057e551dac9b2d3e3f0faa90.svg";